import { render, staticRenderFns } from "./NewsAlerts.vue?vue&type=template&id=8a7276a8&"
import script from "./NewsAlerts.vue?vue&type=script&lang=js&"
export * from "./NewsAlerts.vue?vue&type=script&lang=js&"
import style0 from "./NewsAlerts.vue?vue&type=style&index=0&id=8a7276a8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports